<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>SUB DEPARTMENT<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="subdepartments" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="subdepartmentColumns" [selectionField]="'SubDepartment_Id'"
            [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'"
            (downloadEntities)="onExcelExport()" (addEntity)="addSubDepartment($event)"
            (editEntity)="editSubDepartment($event)" (refreshEntities)="refreshSubDepartments($event)"
            (deleteEntity)="deleteSubDepartment($event)" (onPaginationChange)="onPaginationChange($event)"
            [serverPagination]="true" [pageSizes]="pageSizes" [pageSize]="defaultPageSize" [skip]="pageSkip"
            (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearSubDepartment()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Sub Department Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'SubDepartmentName'" [(ngModel)]="entity.SubDepartmentName"
                     ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                        [fieldName]="'SubDepartmentPrefix'" [(ngModel)]="entity.SubDepartmentPrefix" ngDefaultControl>
                    </textbox>

                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Sub Department Head'" [formData]="entity" [data]="employees"
                        [class]="'form-control'" [mandatory]="false" [filterable]="true"
                        (filterChanged)="getAllEmployees($event)" [(ngModel)]="entity.Emp_Ref_Id"
                        [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'" [fieldName]="'Emp_Ref_Id'"
                        [selectedItem]="selectedEmployee" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Department'" [formData]="entity" [data]="departments" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllDepartments($event)"
                        [(ngModel)]="entity.Department_Id" [textField]="'DepartmentName'" [valueField]="'Department_Id'"
                        [fieldName]="'Department_Id'" [selectedItem]="selectedDepartment" ngDefaultControl>
                    </dropdown>
                </div> 
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllCompany($event)"
                        [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'"
                        [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                    </dropdown>
                </div> -->
            </div>

            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Division'" [formData]="entity" [data]="divisions" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllDivisions($event)"
                        [(ngModel)]="entity.Division_Id" [textField]="'DivisionName'" [valueField]="'Division_Id'"
                        [fieldName]="'Division_Id'" [selectedItem]="selectedDivision" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Location'" [formData]="entity" [data]="locations" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllLocations($event)"
                        [(ngModel)]="entity.Location_Id" [textField]="'LocationName'" [valueField]="'Location_Id'"
                        [fieldName]="'Location_Id'" [selectedItem]="selectedLocation" ngDefaultControl>
                    </dropdown>
                </div>
            </div> -->


           

            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>
    </div>
</div>

<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Sub Department Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="SubDepartmentName" class="label label-1"> Sub Department Name : </label> {{details.SubDepartmentName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="SubDepartmentPrefix" class="label label-1">Code : </label> {{details.SubDepartmentPrefix}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="EmployeeName" class="label label-1">Sub Department Head : </label> {{details.EmployeeName}}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="DepartmentName" class="label label-1"> Department : </label> {{details.DepartmentName}}
          </div>
        </div>
        </div>
    </kendo-dialog>

<kendo-excelexport [data]="subdepartments.data" [collapsible]="true" fileName="SubDepartment.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="SubDepartmentName" title="Sub Department" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="SubDepartmentPrefix" title="Code" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmployeeName" title="Head" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column> -->
    <!-- <kendo-excelexport-column field="DivisionName" title="Division" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="LocationName" title="Name" [width]="200">
    </kendo-excelexport-column>-->
    <kendo-excelexport-column field="DepartmentName" title="Department" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>